<template>
  <section class="relative w-full custom-scrollbar overflow-x">
    <div class="overflow-x-auto custom-scrollbar">
      <table class="w-full mt-6 bg-white table-auto min-w-max">
        <thead class="text-gray-400 bg-white border-b border-gray-200">
          <tr>
            <th class="p-3 text-sm text-left">Name</th>
            <th class="p-3 text-sm text-left">Number</th>
            <th class="p-3 text-sm text-left">Default</th>
            <th class="p-3 text-sm text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="border-b"
            v-for="bankPayrun in banksPayrun"
            :key="bankPayrun._id"
          >
            <td class="p-3 text-sm">{{ bankPayrun.bank_name }}</td>
            <td class="p-3 text-sm">{{ bankPayrun.account_number }}</td>
            <td class="flex justify-start p-3">
              <SwitchButton :value="bankPayrun.is_default" />
            </td>
            <td class="p-3">
              <div class="flex items-center">
                <Button
                  class="mr-3 rounded-full shadow-none hover:bg-blue-100 text-primary"
                  @click="$emit('on-edit', bankPayrun)"
                >
                  <font-awesome-icon icon="fa-pen-to-square" />
                </Button>
                <Button
                  class="text-red-500 rounded-full shadow-none hover:bg-red-100"
                  @click="$emit('on-delete', bankPayrun._id)"
                >
                  <font-awesome-icon icon="fa-trash-alt" />
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import SwitchButton from "@/components/SwitchButton.vue";
import Button from "@/components/Button.vue";
export default {
  name: "TableBankPayrun",
  props: {
    banksPayrun: {
      type: Array,
      required: true,
    },
  },
  components: {
    SwitchButton,
    Button,
  },
};
</script>
